module.exports = __webpack_public_path__ + "static/media/Google-Play.e8b38acf.svg";